// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"39":"e2c18517","480":"057b2824","803":"e2c18517"}[chunkId] + ".chunk.css";
};